// public/js/features/distribution/api.js
export async function loadDistribution() {
  const res = await window.authenticatedFetch('api/v1/admin/distribution');
  if (!res.ok) throw new Error(`Failed to load distribution (${res.status})`);
  return await res.json();   // { models, tenants:[{tenantId,name,onHand,requested,totalDevices}], totals, requestedTotals }
}

export async function listTenantRequests(tenantId) {
  const res = await window.authenticatedFetch(`api/v1/admin/distribution/tenants/${encodeURIComponent(tenantId)}/requests`);
  if (!res.ok) throw new Error(`Failed to load requests (${res.status})`);
  return (await res.json()).requests || [];
}

export async function createRequest(payload) {
  const res = await window.authenticatedFetch('api/v1/admin/distribution/requests', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Failed to create request (${res.status})`);
  return (await res.json()).request;
}

export async function updateRequest(requestId, payload) {
  const res = await window.authenticatedFetch(`api/v1/admin/distribution/requests/${encodeURIComponent(requestId)}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error(`Failed to update request (${res.status})`);
  return (await res.json()).request;
}

// ── Orders + shipping addresses (docs/device-distribution.md "Orders") ──────
const json = async (res, what) => {
  if (!res.ok) {
    let msg = `${what} (${res.status})`;
    let body = null;
    try { body = await res.json(); msg = body.error || msg; } catch {}
    // Keep the body on the error: some endpoints save the record and still
    // report a failure (a shop push that could not reach the shop), and the
    // caller wants to show the saved state next to the message.
    const err = new Error(msg); err.body = body; err.status = res.status;
    throw err;
  }
  return res.json();
};
const post = (url, body, method = 'POST') => window.authenticatedFetch(url, {
  method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
});

export async function listAddresses(tenantId) {
  return (await json(await window.authenticatedFetch(`api/v1/admin/distribution/tenants/${encodeURIComponent(tenantId)}/addresses`), 'Failed to load addresses')).addresses || [];
}
export async function createAddress(tenantId, payload) {
  return (await json(await post(`api/v1/admin/distribution/tenants/${encodeURIComponent(tenantId)}/addresses`, payload), 'Failed to save address')).address;
}
export async function updateAddress(tenantId, addressId, payload) {
  return (await json(await post(`api/v1/admin/distribution/tenants/${encodeURIComponent(tenantId)}/addresses/${encodeURIComponent(addressId)}`, payload, 'PATCH'), 'Failed to update address')).address;
}
export async function deleteAddress(tenantId, addressId) {
  return json(await window.authenticatedFetch(`api/v1/admin/distribution/tenants/${encodeURIComponent(tenantId)}/addresses/${encodeURIComponent(addressId)}`, { method: 'DELETE' }), 'Failed to delete address');
}

export async function listOrders() {
  return (await json(await window.authenticatedFetch('api/v1/admin/distribution/orders'), 'Failed to load orders')).orders || [];
}
export async function createOrder(payload) {
  return json(await post('api/v1/admin/distribution/orders', payload), 'Failed to create order');
}
export async function updateOrder(orderId, payload) {
  return json(await post(`api/v1/admin/distribution/orders/${encodeURIComponent(orderId)}`, payload, 'PATCH'), 'Failed to update order');
}
export const datenblattUrl = (orderId) => `api/v1/admin/distribution/orders/${encodeURIComponent(orderId)}/datenblatt`;

// Tenant side (read-only).
export async function listDeliveries() {
  return (await json(await window.authenticatedFetch('api/v1/deliveries'), 'Failed to load deliveries')).orders || [];
}
